/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SkillVersion,
  SkillVersion$inboundSchema,
  SkillVersion$Outbound,
  SkillVersion$outboundSchema,
} from "./skillversion.js";

export type SkillVersionList = {
  object?: "list" | undefined;
  data: Array<SkillVersion>;
  firstId: string | null;
  hasMore: boolean;
  lastId: string | null;
};

/** @internal */
export const SkillVersionList$inboundSchema: z.ZodType<
  SkillVersionList,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list").default("list"),
  data: z.array(SkillVersion$inboundSchema),
  first_id: z.nullable(z.string()),
  has_more: z.boolean(),
  last_id: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    "first_id": "firstId",
    "has_more": "hasMore",
    "last_id": "lastId",
  });
});
/** @internal */
export type SkillVersionList$Outbound = {
  object: "list";
  data: Array<SkillVersion$Outbound>;
  first_id: string | null;
  has_more: boolean;
  last_id: string | null;
};

/** @internal */
export const SkillVersionList$outboundSchema: z.ZodType<
  SkillVersionList$Outbound,
  z.ZodTypeDef,
  SkillVersionList
> = z.object({
  object: z.literal("list").default("list" as const),
  data: z.array(SkillVersion$outboundSchema),
  firstId: z.nullable(z.string()),
  hasMore: z.boolean(),
  lastId: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    firstId: "first_id",
    hasMore: "has_more",
    lastId: "last_id",
  });
});

export function skillVersionListToJSON(
  skillVersionList: SkillVersionList,
): string {
  return JSON.stringify(
    SkillVersionList$outboundSchema.parse(skillVersionList),
  );
}
export function skillVersionListFromJSON(
  jsonString: string,
): SafeParseResult<SkillVersionList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillVersionList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillVersionList' from JSON`,
  );
}
